import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, Paper, Card, Typography } from '@material-ui/core';
import AcutePatientsByMonth from "./dashboard/AcutePatientsByMonth";
import PatientFacilities from './dashboard/PatientFacilities'
import DischargeDispositionType from './dashboard/DischargeDispositionType';

const Home = () => {

    return (
        <div className="maincontent" style={{ padding: 24 }}>
            <Grid container direction="row" justifyContent="space-between" spacing={3}>
                <Grid item md={12}>
                    <Typography variant="h6" gutterBottom>
                        Patient Population in the last 6 months
                </Typography>
                </Grid>
                    <Grid item lg={6} md={12} xs={12}>
                        <Card elevation={3} style={{ padding: 20 }}><AcutePatientsByMonth /></Card>
                    </Grid>
                    <Grid item lg={6} md={12} xs={12}>
                        <Card elevation={3} style={{ padding: 20 }}><PatientFacilities /></Card>
                </Grid>   
                    <Grid item lg={6} md={12} xs={12}>
                        <Card elevation={3} style={{ padding: 20 }}><DischargeDispositionType /></Card>
                </Grid>
            </Grid>
        </div>
    )
}

export default connect()(Home);
